import { useEffect } from 'react';

const lockState = {
  count: 0,
  saved: null,
};

const applyLock = () => {
  lockState.saved = {
    bodyOverflow: document.body.style.overflow,
    htmlOverflow: document.documentElement.style.overflow,
    bodyPaddingRight: document.body.style.paddingRight,
  };

  const scrollbarWidth = window.innerWidth - document.documentElement.clientWidth;

  document.body.style.overflow = 'hidden';
  document.documentElement.style.overflow = 'hidden';
  if (scrollbarWidth > 0) {
    document.body.style.paddingRight = `${scrollbarWidth}px`;
  }
};

const releaseLock = () => {
  if (!lockState.saved) {
    return;
  }

  const { bodyOverflow, htmlOverflow, bodyPaddingRight } = lockState.saved;
  document.body.style.overflow = bodyOverflow;
  document.documentElement.style.overflow = htmlOverflow;
  document.body.style.paddingRight = bodyPaddingRight;
  lockState.saved = null;
};

const acquireLock = () => {
  if (lockState.count === 0) {
    applyLock();
  }
  lockState.count += 1;
};

const releaseOneLock = () => {
  lockState.count = Math.max(0, lockState.count - 1);
  if (lockState.count === 0) {
    releaseLock();
  }
};

/**
 * Prevents background page scrolling while overlays/modals are open.
 * Uses reference counting so nested overlays (e.g. scanner over maintenance modal) restore scroll correctly.
 */
export const useBodyScrollLock = (locked = true) => {
  useEffect(() => {
    if (!locked) {
      return undefined;
    }

    acquireLock();
    return () => releaseOneLock();
  }, [locked]);
};

export default useBodyScrollLock;
